import React, { useState, useEffect, useRef } from 'react'
import { Card, Button, Input, Space, Badge, Checkbox, Radio } from 'antd'
import { FilterFilled, SearchOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import {
  formatMessageNew,
  downLoadFileBlob,
  formatStartTime,
  formatEndTime,
  initValueAndLabel,
  uniqueFun,
  isChineseFun,
  dateFormatYearMonthDay,
  paginationInit,
  initCurryingObj
} from '@/utils/common'
import { getCscDetailReport, cscDetailDownload } from '@/services/rfid/csc/outboundDetail'
import { getCscSummaryDropDown } from '@/services/rfid/csc/outboundSummary'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
import { DIVISION, CARTON_PE, RETAG_LIST } from '@/utils/types'
const startMonth = dayjs().subtract(6, 'day')
const endMonth = dayjs().subtract(0, 'day')
const divisionObj = initCurryingObj(DIVISION)
let selectOptions = {}
let filtersInit = {
  orderNumber: [],
  boxNumber: [],
  platformOrderNumber: [],
  expressTrackingNumber: [],
  gap: [],
  cartonResultList: []
}
const OutboundDetailReport = () => {
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [filtersObj, setFiltersObj] = useState({ ...filtersInit })
  const mounting = useRef(false)
  let formRef = useRef(null)
  let searchListInit = [
    {
      type: 'select',
      label: 'languageObj.outboundDetail.cscName',
      key: 'cscNameList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRange',
      label: 'languageObj.outboundDetail.giTime',
      key: 'rangeDate',
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > dayjs().endOf('day')
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true',
      allowClear: false
    },
    {
      type: 'select',
      label: 'languageObj.outboundDetail.orderType',
      key: 'orderTypeList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.outboundDetail.shipFrom',
      key: 'shipFromList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.outboundDetail.shipTo',
      key: 'shipToList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.outboundDetail.pe',
      key: 'divisionList',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: CARTON_PE,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  const [cartonResultList, setCartonResultList] = useState([])
  const handleSearch = confirm => {
    mounting.current = true
    confirm()
  }
  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => {
      return (
        <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
          <Input
            size="small"
            placeholder={`${formatMessageNew('languageObj.commonLocale.placeholderInput')}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(confirm)}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(confirm, selectedKeys, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
            >
              {formatMessageNew('languageObj.commonLocale.search')}
            </Button>
            <Button
              onClick={() => {
                clearFilters && clearFilters()
                confirm()
              }}
              size="small"
            >
              {formatMessageNew('languageObj.commonLocale.clear')}
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close()
              }}
            >
              {formatMessageNew('languageObj.commonLocale.close')}
            </Button>
          </Space>
        </div>
      )
    },
    filterIcon: filtered => {
      return (
        <Badge color="#1677ff" dot={filtered}>
          <FilterFilled
            style={{
              color: filtered ? '#0958d9' : '#1677ff'
            }}
          />
        </Badge>
      )
    }
  })
  const getColumnSelectSearchProps = (dataIndex, list, type) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => {
      return (
        <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
          <div className="pb8">
            {type === 'radio' ? (
              <Radio.Group
                style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                value={selectedKeys[0]}
                options={list}
              />
            ) : (
              <Checkbox.Group
                style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
                value={selectedKeys}
                onChange={e => {
                  setSelectedKeys(e ? e : [])
                }}
              >
                {list.map((item, idx) => {
                  return (
                    <Checkbox key={idx} value={item.value}>
                      {item.label}
                    </Checkbox>
                  )
                })}
              </Checkbox.Group>
            )}
          </div>
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(confirm, selectedKeys, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
            >
              {formatMessageNew('languageObj.commonLocale.search')}
            </Button>
            <Button
              onClick={() => {
                clearFilters && clearFilters()
                confirm()
              }}
              size="small"
            >
              {formatMessageNew('languageObj.commonLocale.clear')}
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close()
              }}
            >
              {formatMessageNew('languageObj.commonLocale.close')}
            </Button>
          </Space>
        </div>
      )
    },
    filterIcon: filtered => {
      return (
        <Badge color="#1677ff" dot={filtered}>
          <FilterFilled
            style={{
              color: filtered ? '#0958d9' : '#1677ff'
            }}
          />
        </Badge>
      )
    }
  })
  // 拆分单元格
  const splitCell = (record, key) => {
    return (record.cscScanVoList || []).map((item, idx) => {
      if (item.epcList) {
        return (
          <div key={idx} className="itemWrapper p8 itemLine" style={{ height: Math.min(item.epcList.length, 3) * 68 }}>
            {item[key]}
          </div>
        )
      } else {
        return (
          <div key={idx} className="itemWrapper p8 itemLine">
            {item[key]}
          </div>
        )
      }
    })
  }
  const tableColumns = [
    {
      title: () => formatMessageNew('languageObj.outboundDetail.cscName'),
      dataIndex: 'cscName',
      fixed: 'left',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.orderType'),
      dataIndex: 'orderType',
      width: 150,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
      // onCell: record => {
      //   return {
      //     rowSpan: record.siteRowSpan_orderType
      //   }
      // }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.orderNo'),
      width: 120,
      dataIndex: 'orderNumber',
      filteredValue: filtersObj.orderNumber,
      ...getColumnSearchProps('orderNumber'),
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.cartonNo'),
      width: 120,
      dataIndex: 'boxNumber',
      filteredValue: filtersObj.boxNumber,
      ...getColumnSearchProps('boxNumber'),
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.platformOrderNo'),
      width: 180,
      dataIndex: 'platformOrderNumber',
      filteredValue: filtersObj.platformOrderNumber,
      ...getColumnSearchProps('platformOrderNumber'),
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.expressTrackingNo'),
      width: 180,
      dataIndex: 'expressTrackingNumber',
      filteredValue: filtersObj.expressTrackingNumber,
      ...getColumnSearchProps('expressTrackingNumber'),
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.sku'),
      width: 130,
      dataIndex: 'productCode',
      onCell: record => {
        return {
          className: 'cellClass'
        }
      },
      render: (text, record) => {
        return splitCell(record, 'productCode')
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.pe'),
      width: 100,
      dataIndex: 'division',
      onCell: record => {
        return {
          className: 'cellClass'
        }
      },
      render: (text, record) => {
        return (record.cscScanVoList || []).map((item, idx) => {
          if (item.epcList) {
            return (
              <div
                key={idx}
                className="itemWrapper p8 itemLine"
                style={{ height: Math.min(item.epcList.length, 3) * 68 }}
              >
                {divisionObj[item.division]}
              </div>
            )
          } else {
            return (
              <div key={idx} className="itemWrapper p8 itemLine">
                {divisionObj[item.division]}
              </div>
            )
          }
        })
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.actualOrderQty'),
      width: 150,
      dataIndex: 'actualQty',
      onCell: record => {
        return {
          className: 'cellClass'
        }
      },
      render: (text, record) => {
        return splitCell(record, 'actualQty')
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.rfidScanQty'),
      width: 120,
      dataIndex: 'rfidScanQty',
      onCell: record => {
        return {
          className: 'cellClass'
        }
      },
      render: (text, record) => {
        return splitCell(record, 'rfidScanQty')
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.gap'),
      dataIndex: 'gap',
      width: 80,
      filteredValue: filtersObj.gap,
      ...getColumnSelectSearchProps('gap', RETAG_LIST),
      render: text => {
        return <div style={{ color: text === 'Y' ? 'red' : 'green' }}>{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.exceptionReason'),
      width: 180,
      dataIndex: 'cartonResultList',
      filteredValue: filtersObj.cartonResultList,
      ...getColumnSelectSearchProps('cartonResultList', cartonResultList),
      render: (text, record) => {
        return <div className="word_break_all">{record.cartonResultName}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.shipFrom'),
      width: 100,
      dataIndex: 'shipFrom',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.shipFromName'),
      width: 160,
      dataIndex: 'shipFromName',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.shipTo'),
      width: 100,
      dataIndex: 'shipTo',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.shipToName'),
      width: 160,
      dataIndex: 'shipToName',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.orderConfirmedTime'),
      width: 170,
      dataIndex: 'orderConfirmedTime',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.orderScheduledTime'),
      width: 170,
      dataIndex: 'orderScheduledTime',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.orderPackedTime'),
      width: 160,
      dataIndex: 'orderPackedTime',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.orderCreateTime'),
      width: 160,
      dataIndex: 'orderCreateTime',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.giTime'),
      width: 160,
      dataIndex: 'giDate',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.orderUpc'),
      width: 120,
      dataIndex: 'upc',
      onCell: record => {
        return {
          className: 'cellClass'
        }
      },
      render: (text, record) => {
        return splitCell(record, 'upc')
      }
    },
    {
      title: () =>
        formatMessageNew('languageObj.outboundDetail.rfidEpc') +
        '-' +
        formatMessageNew('languageObj.outboundDetail.epcDecodedUpc'),
      width: 240,
      dataIndex: 'rfidEpc',
      onCell: record => {
        return {
          className: 'cellClass'
        }
      },
      render: (text, record) => {
        return (record.cscScanVoList || []).map((item, idx) => {
          if (item.epcList) {
            return (
              <div key={idx} className="overflowWrapper">
                {(item.epcList || []).map((itemSec, idxSec) => {
                  let resls = itemSec.split('-')
                  return (
                    <div key={idxSec} className="word_break_all itemWrapper p8 itemLine2">
                      <div>
                        <span>{resls[0]}</span>
                        {resls[1] && '-'}
                      </div>
                      {resls[1] && <div style={{ color: resls[1] === item.upc ? 'inherit' : 'red' }}>{resls[1]}</div>}
                    </div>
                  )
                })}
              </div>
            )
          } else {
            return <div key={idx} className="word_break_all itemWrapper p8 itemLine2"></div>
          }
        })
      }
    },
    {
      title: () => formatMessageNew('languageObj.outboundDetail.scanTime'),
      width: 160,
      dataIndex: 'scanTime',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]
  useEffect(() => {
    mounting.current && searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    getSelectOptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSelectOptions = () => {
    getCscSummaryDropDown().then(res => {
      res.resultData.forEach(item => {
        selectOptions[item.type] = item.value
      })
      let resultList = initValueAndLabel(uniqueFun(selectOptions['6'] || [], 2))
      setCartonResultList(resultList)
      searchListInit.forEach(itemFirst => {
        if (
          itemFirst.key === 'shipFromList' ||
          itemFirst.key === 'shipToList' ||
          itemFirst.key === 'cscNameList' ||
          itemFirst.key === 'orderTypeList'
        ) {
          let arr = []
          if (itemFirst.key === 'shipFromList') {
            arr = selectOptions['1'] || []
          }
          if (itemFirst.key === 'shipToList') {
            arr = selectOptions['2'] || []
          }
          if (itemFirst.key === 'cscNameList') {
            let ls = selectOptions['5'] || []
            arr = ls.map(mapItem => {
              let l = mapItem.split(',')
              return {
                value: l[0],
                label: l[1]
              }
            })
          }
          if (itemFirst.key === 'orderTypeList') {
            arr = (selectOptions['3'] || []).concat(selectOptions['4'] || [])
          }
          if (itemFirst.key === 'cscNameList') {
            itemFirst.selectList = uniqueFun(arr, 1, 'label')
          } else {
            itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 2))
          }
        }
      })
      setSearchList([...searchListInit])
    })
  }
  const downLoadFun = () => {
    const params = {
      ...getParams(),
      ...isChineseFun()
    }
    cscDetailDownload(params).then(res => {
      downLoadFileBlob(res)
    })
  }
  const searchDataBtn = () => {
    mounting.current = true
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    mounting.current = true
    formRef && formRef.current.clearForm()
    setFiltersObj({ ...filtersInit })
    setQueryFlag(!queryFlag)
  }
  const handleTableChange = (pagina, filters) => {
    mounting.current = true
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    console.log('filters', filters)

    setFiltersObj(filters)
    setQueryFlag(!queryFlag)
  }
  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const { rangeDate } = info
    const { orderNumber, boxNumber, platformOrderNumber, expressTrackingNumber, gap, cartonResultList } = filtersObj
    const params = {
      ...info,
      startGiDate: formatStartTime(rangeDate),
      endGiDate: formatEndTime(rangeDate),
      cartonResultList,
      orderNumber: orderNumber && orderNumber.length > 0 ? orderNumber[0] : '',
      boxNumber: boxNumber && boxNumber.length > 0 ? boxNumber[0] : '',
      platformOrderNumber: platformOrderNumber && platformOrderNumber.length > 0 ? platformOrderNumber[0] : '',
      expressTrackingNumber: expressTrackingNumber && expressTrackingNumber.length > 0 ? expressTrackingNumber[0] : ''
    }
    if (gap) {
      if (gap.length === 1) {
        params.gap = gap[0]
      } else if (gap.length === 2) {
        params.gap = ''
      } else {
        params.gap = ''
      }
    } else {
      params.gap = ''
    }
    delete params.rangeDate
    return params
  }
  const searchDataFun = () => {
    const params = {
      ...getParams(),
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }
    getCscDetailReport(params).then(res => {
      const dt = res.resultData
      let records = dt.records
      // let dt0 = { ...records[0] }
      // for (let idx = 0; idx < records.length; idx++) {
      //   let element = records[idx]
      //   // SKU level合并单元格
      //   if (dt0.sku === element.sku) {
      //     handleRowSpan(dt0, records, element, idx, mergeList)
      //     // 与前一行相同，增加合并行数，当前行不显示
      //     setRowSpan(dt0, records, element, idx, 'sku')
      //   } else {
      //     // 与前一行不同，重置计数
      //     initRowSpan(dt0, records, element, idx, ['sku', ...mergeList])
      //   }
      // }
      setTableList(records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            // showCollapseBtn={true}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container mt30 pt10">
          <AntdTable
            // rowKey={record => record.id}
            // 独一无二的表示，不能重复
            columnsKey={'columns_outboundDetailReport'}
            onDownload={downLoadFun}
            dataSource={tableList}
            columns={tableColumns}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </Card>
    </div>
  )
}
export default OutboundDetailReport
